var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardimage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 70.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6768 84.3245L84.5851 79.4175L88.3097 83.1447L83.4027 88.0504L79.6768 84.3245Z",
    fill: "#B0BDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8606 83.1449L83.4054 80.6001L87.1326 84.3234L84.5878 86.8682L80.8606 83.1449Z",
    fill: "#DFE9EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5879 84.318L84.4949 79.4097L86.0398 80.9545L81.1327 85.8641L79.5879 84.318Z",
    fill: "#B0BDC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.859 40.6549C71.2918 29.0877 52.3988 29.0877 40.7031 40.6549C29.0074 52.222 29.136 71.115 40.7031 82.8107C52.2703 94.3779 71.1633 94.3779 82.859 82.8107C94.5546 71.115 94.5546 52.222 82.859 40.6549ZM80.16 79.9832C70.0066 90.1366 53.684 90.1366 43.6592 79.9832C33.5058 69.8298 33.5058 53.5072 43.6592 43.4824C53.8126 33.329 70.1351 33.329 80.16 43.4824C90.1848 53.5072 90.1848 69.8298 80.16 79.9832Z",
    fill: "#679DEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8029 42.7107C70.3925 32.3002 53.4274 32.3002 42.8884 42.7107C32.478 53.1211 32.478 70.0863 42.8884 80.6252C53.2988 91.0357 70.264 91.0357 80.8029 80.6252C91.2134 70.2148 91.2134 53.2496 80.8029 42.7107ZM79.3892 79.2114C69.7499 88.8507 53.9415 88.8507 44.3022 79.2114C34.6629 69.5722 34.6629 53.7637 44.3022 44.1244C53.9415 34.4851 69.7499 34.4851 79.3892 44.1244C89.0285 53.7637 89.0285 69.5722 79.3892 79.2114Z",
    fill: "#B0BDC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.9186 67.6447C67.5646 75.9988 53.9411 75.9988 45.587 67.6447C43.4021 65.4598 41.7313 62.8893 40.7031 60.0618C40.189 66.2309 42.2454 72.5286 46.8722 77.1555C55.2263 85.5095 68.8498 85.5095 77.2039 77.1555C83.373 70.9863 84.9153 61.9896 82.0878 54.4067C81.5737 59.2906 79.5173 63.9175 75.9186 67.6447Z",
    fill: "#015BE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7769 89.4878L89.6836 80.5811L107.407 98.3032L98.5003 107.21L80.7769 89.4878Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7776 87.4892L87.6833 82.5796L105.407 100.299L100.501 105.208L82.7776 87.4892Z",
    fill: "#575B5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.078 97.3336C110.492 98.7474 99.0532 110.315 97.5109 108.901L96.6112 108.001C95.1974 106.587 106.636 95.0202 108.178 96.434L109.078 97.3336Z",
    fill: "#B0BDC6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.15 99.2624C108.564 100.676 100.981 108.388 99.4387 106.974L98.539 106.074C97.1252 104.66 104.708 96.9489 106.25 98.3627L107.15 99.2624Z",
    fill: "#DFE9EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardimage1);
export default __webpack_public_path__ + "static/media/cardimage1.c3f95f3fe3b4ece4f33cb4bf96152d13.svg";
export { ForwardRef as ReactComponent };